var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('vue-menu',{attrs:{"menu":_vm.menu,"title":"关于易格"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banxx",staticStyle:{"background":"url('/images/yrxm.jpg') no-repeat center center","background-size":"cover"}},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"text"},[_c('h3',[_vm._v("关于易格")]),_c('p',[_vm._v("首页 / 关于易格")])])])])
}]

export { render, staticRenderFns }